/** API sentinel for P&L on Havala sender or receiver. */
export const HAVALA_PL_PARTY_ID = 0;

export const HAVALA_PL_LABEL = 'P&L';

/** Name part shown after " - " in the party field (matches normal code - name). */
export const HAVALA_PL_PARTY_NAME = 'Profit and loss';

/** Full display value for the input after P&L is resolved. */
export const HAVALA_PL_DISPLAY = `${HAVALA_PL_LABEL} - ${HAVALA_PL_PARTY_NAME}`;

/**
 * Recognizes P&L / PnL (any case) for Havala Lena/Dena; API uses partyId 0.
 * Also matches the resolved display form "P&L - Profit and loss" (first segment before " - ").
 */
export function normalizePlAccountInput(raw: string): string | null {
  const s = raw.trim();
  if (!s) return null;

  const compact = s.replace(/\s+/g, '');
  if (/^P&L$/i.test(compact) || /^PNL$/i.test(compact)) return HAVALA_PL_LABEL;

  const firstSeg = s.split(/\s*-\s*/)[0].trim().replace(/\s+/g, '');
  if (/^P&L$/i.test(firstSeg) || /^PNL$/i.test(firstSeg)) return HAVALA_PL_LABEL;

  return null;
}
